"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _auth = require("../utils/auth");

var _redux = require("../redux"); // import components


var useAuth = function useAuth() {
  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      userLoaded = _ref.auth.userLoaded;

  var dispatch = (0, _redux.useAppDispatch)();

  var _ref2 = (0, _react.useState)(0),
      _ref3 = _slicedToArray(_ref2, 2),
      timer = _ref3[0],
      setTimer = _ref3[1];

  var user = (0, _auth.getUser)();
  (0, _react.useEffect)(function () {
    var intervalID = null;

    if (user !== null && user !== void 0 && user.authToken) {
      intervalID = setInterval(function () {
        setTimer(function (time) {
          return time + 1;
        });
      }, 60000); // 60 seconds
    } // Clear timer


    return function () {
      intervalID && clearInterval(intervalID);
    };
  }, []);
  (0, _react.useEffect)(function () {
    (user === null || user === void 0 ? void 0 : user.authToken) && userLoaded && dispatch(_redux.authActions.refreshToken());
  }, [timer]);
  (0, _react.useEffect)(function () {
    (user === null || user === void 0 ? void 0 : user.authToken) && !userLoaded && dispatch(_redux.authActions.getAuthUser());
  }, []);
};

var _default = useAuth;
exports.default = _default;